<template>
  <div :class="['search-tab', 'college']">
    <el-tabs type="card" v-model="currentTab" @tab-change="handleTabChange">
      <el-tab-pane name="1">
        <template #label>
          <span class="custom-tabs-label">
            <img :src="icon.hIcon" alt="" srcset="" />
            <span class="fs-xl">{{ label }}综合ISTEM结果</span>
          </span>
        </template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref } from 'vue'

import hIcon from '@/assets/icons/hospital.png'
import plusIcon from '@/assets/icons/plus.png'

import INFO from '../../constant.js'

const emits = defineEmits(['tab-change'])

const props = defineProps({
  type: {
    type: String
  }
})
const currentTab = ref('1')

const handleTabChange = (value) => {
  // if (currentTab.value === value) return
  emits('tab-change', value)
}

const icon = {
  hIcon,
  plusIcon
}
const label = INFO[props.type].name
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/search-tab.scss';
</style>
